import Carousel from 'Assets/js/lib/carousel'
import { CARTSTATES, THEME } from 'Assets/js/lib/constants'
import { addItemById } from 'Assets/js/lib/cart'
import { executeGraphQlQuery } from 'Assets/js/lib/product'
import { scrollToHandler } from 'Assets/js/lib/smoothscroll'
import { formatMoney } from 'Assets/js/lib/template-helpers'
;(function () {
  const EVENTS = {
    dataFetch: 'productPage:dataFetch',
    relatedDataFetch: 'productPage:relatedDataFetch',
    fieldsetValidate: 'productPage:fieldsetValidate',
    formSubmit: 'productPage:formSubmit',
    variantChange: 'productPage:variantChange',
    productLoading: 'productPage:loading',
    productChange: 'productPage:productChange',
    postProductChange: 'productPage:postProductChange',
    lightboxChange: 'productPage:lightboxChange',
  }

  const decodeHTMLEntities = (() => {
    const textArea = document.createElement('textarea')
    return (message) => {
      textArea.innerHTML = message
      return textArea.value
    }
  })()

  const getSelectedVariantData = ({ fields }) => {
    const options = fields.map((element) => {
      if (element.tagName === 'SELECT') {
        return element.value
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find(
          (radio) => radio.checked,
        )?.value
      }

      return undefined
    })

    return SAXX.Product.Data.variants.find((variant) => {
      return !variant.options
        .map((option, index) => {
          return options[index] === option
        })
        .includes(false)
    })
  }

  let controller = null
  const productPageNextLoad = (nextUrl, suppressPushState = false) => {
    SAXX.App.emit(EVENTS.productLoading)

    if (controller) {
      controller.abort()
    }

    const url = new URL(nextUrl, window.location.origin)
    url.searchParams.set('section_id', 'main-product')

    controller = new AbortController()
    const signal = controller.signal
    fetch(url.toString(), { signal })
      .then((res) => res.text())
      .then((response) => {
        const productPage = new DOMParser().parseFromString(
          response,
          'text/html',
        )

        url.searchParams.delete('section_id')
        if (!suppressPushState) {
          window.history.pushState({}, '', url)
        }

        document.getElementById('mainProductData').remove()

        const script = document.createElement('script')
        script.id = 'mainProductData'
        script.text = productPage.getElementById('mainProductData').innerText
        document.getElementById('mainPageScript').parentNode.appendChild(script)

        const details = {
          url: url.pathname,
          variant: url.searchParams.get('variant') ?? null,
          productPage,
        }

        SAXX.App.emit(EVENTS.productChange, null, details)
        SAXX.App.emit(EVENTS.postProductChange, null, details)
        SAXX.App.mount()

        controller = null
      })
      .catch((e) => {
        if (e.name === 'AbortError') return
        console.error(e)
        SAXX.App.emit(EVENTS.productChange)
      })
  }

  const getShopliftAttributeElements = (node) => {
    return {
      price: Array.from(node.querySelectorAll('[data-sl-attribute-p]')),
      compareAtPrice: Array.from(
        node.querySelectorAll('[data-sl-attribute-cap]'),
      ),
      id: Array.from(node.querySelectorAll('[data-sl-pid]')),
    }
  }

  const locally = () => {
    const locallyEndpoint = new URL('https://saxx.locally.com/stores/map.js')
    Object.entries(SAXX.Product.Locally).forEach(([key, value]) => {
      locallyEndpoint.searchParams.append(key, value)
    })

    const script = document.createElement('script')
    script.src = locallyEndpoint.toString()

    const locallyLink = document.createElement('a')
    locallyLink.id = 'lcly-link-0'
    locallyLink.role = 'button'
    locallyLink.href = ''
    locallyLink.target = '_blank'
    locallyLink.classList.add('visually-hidden')
    locallyLink.innerText = 'Product Locator by Locally'
    locallyLink.setAttribute('data-switchlive', 'true')
    locallyLink.setAttribute('data-switchlive-mode', 'auto')
    locallyLink.setAttribute('data-switchlive-id-PL', '6')

    document.getElementById('lcly-button-0').innerHTML = ''
    document.getElementById('lcly-button-0').append(locallyLink)
    document.getElementById('locally-container').innerHTML = ''
    document.getElementById('locally-container').append(script)
  }

  if (document.getElementById('locally-container')) locally()

  const components = {
    mainProduct: SAXX.Init.Component((node, ctx) => {
      let shopliftElements = {
        price: [],
        compareAtPrice: [],
        id: [],
      }

      shopliftElements = getShopliftAttributeElements(node.parentNode)

      ctx.on(EVENTS.variantChange, (_, details) => {
        const url = new URL(window.location)
        url.searchParams.set('variant', details.variant.id)
        window.history.replaceState(null, '', url)

        shopliftElements.price.forEach((ele) =>
          ele.setAttribute('data-sl-attribute-p', details.variant.id),
        )
        shopliftElements.compareAtPrice.forEach((ele) =>
          ele.setAttribute('data-sl-attribute-cap', details.variant.id),
        )
        shopliftElements.id.forEach((ele) =>
          ele.setAttribute('data-sl-pid', details.variant.id),
        )

        if (
          typeof window.bwp === 'object' &&
          typeof window.bwp.updateWidget === 'function'
        ) {
          window.bwp.updateWidget(details.variant.sku, 1)
        }
      })

      ctx.on(EVENTS.productLoading, () => {
        node.classList.add('loading')
      })

      ctx.on(EVENTS.productChange, (_, details) => {
        node.classList =
          details.productPage.querySelector('.main-product').classList
      })

      ctx.on(EVENTS.postProductChange, () => {
        if (
          typeof window.bwp === 'object' &&
          typeof window.bwp.updateWidget === 'function'
        ) {
          window.bwp.updateWidget(SAXX.Product.SelectedOrFirstVariant.sku, 1)
        }

        if (window.nostojs) {
          window.nostojs((api) =>
            api
              .createRecommendationRequest()
              .setElements(['nosto-badges', 'nosto-pdp-badges'])
              .load(),
          )
        }

        if (document.getElementById('locally-container')) locally()

        shopliftElements = getShopliftAttributeElements(node.parentNode)

        node.classList.remove('loading')
      })

      ctx.on('nosto:postRender', () => {
        Array.from(node.querySelectorAll('.main-product--violators')).forEach(
          (container) => {
            container
              .querySelectorAll('.loading-skeleton__text-block')
              .forEach((ele) => ele.remove())
            container.innerHTML = container.innerHTML.trim()
          },
        )
      })

      window.addEventListener('popstate', () => {
        productPageNextLoad(new URL(window.location).toString(), true)
      })
    }),
    mainProductTitleSection: SAXX.Init.Component((node, ctx) => {
      const sectionType = node.getAttribute('data-type')
      ctx.on(EVENTS.productChange, (_, details) => {
        node.innerHTML = details.productPage.querySelector(
          `.main-product--title-section.main-product--title-section__${sectionType}`,
        ).innerHTML
      })
    }),
    mainProductMedia: SAXX.Init.Component((node, ctx) => {
      ctx.on(EVENTS.productChange, (_, details) => {
        node.innerHTML = details.productPage.querySelector(
          '.main-product--media.carousel',
        ).innerHTML

        new Carousel(node)
      })
    }),
    mainProductLightboxCarousel: SAXX.Init.Component((node, ctx) => {
      new Carousel(node)

      ctx.on(EVENTS.lightboxChange, (_, details) => {
        node.dispatchEvent(
          new CustomEvent('select', { detail: { selected: details.selected } }),
        )
      })
    }),
    mainProductLightboxTrigger: SAXX.Init.Component((node, ctx) => {
      node.addEventListener('click', (e) => {
        e.preventDefault()
        const template = document.getElementById(
          `${node.getAttribute('data-lightbox')}`,
        )
        const lightbox = template.content.cloneNode(true)
        const lightboxTarget = template.getAttribute('data-target')

        lightbox.querySelectorAll('[data-lightbox-close]').forEach((node) => {
          node.addEventListener('click', (e) => {
            e.preventDefault()
            const target = document.getElementById(lightboxTarget)
            target.setAttribute('aria-expanded', 'false')
            setTimeout(() => {
              target.remove()
            }, 300)
          })
        })

        lightbox
          .querySelectorAll('.main-product--lightbox-thumbnail')
          .forEach((thumb, i) => {
            thumb.addEventListener('click', () => {
              ctx.emit(EVENTS.lightboxChange, null, { selected: i })
            })
          })

        document.body.appendChild(lightbox)
        SAXX.App.mount()

        setTimeout(() => {
          document
            .getElementById(lightboxTarget)
            .setAttribute('aria-expanded', 'true')
        }, 50)
      })
    }),
    mainProductSpecToggle: SAXX.Init.Component((node) => {
      node.addEventListener('click', () => {
        node.parentNode.classList.toggle('active')
      })
    }),
    mainProductFieldset: SAXX.Init.Component((node, ctx) => {
      ctx.on(EVENTS.fieldsetValidate, () => {
        if (node.disabled) return

        const fieldsetIsInvalid =
          Array.from(
            node.querySelectorAll('input:not([type="hidden"]),select,textarea'),
          ).filter((ele) => !ele.checkValidity()).length > 0

        node.classList.toggle('error', fieldsetIsInvalid)
      })
    }),
    mainProductSwatches: SAXX.Init.Component((node, ctx) => {
      const showAllButton = node.querySelector('[data-show-all]')
      const title = node.querySelector('[data-name]')
      let selectedVariantTitle = SAXX.Product.SelectedVariant?.title ?? null

      showAllButton.addEventListener('click', () => {
        node.classList.toggle('expanded')
        showAllButton.innerHTML =
          node.classList.contains('expanded') ? 'Show Less' : 'Show All'
      })

      ctx.on(EVENTS.dataFetch, (_, data) => {
        const variants = data[node.getAttribute('data-type')] ?? []
        if (variants.length === 0) {
          node.setAttribute('disabled', true)
          return
        }

        const colourway = decodeHTMLEntities(SAXX.Product.Colourway)
        const name = variants.find(
          (variant) => variant.colourway.value === colourway,
        )
        if (name) {
          title.innerHTML = name.colourway.value
        }
        const variantDetails = new Map()

        node.classList.toggle('extra-large-list', variants.length > 50)

        node.querySelector('[data-count]').innerHTML =
          `${variants.length} Colors`

        node.querySelector('[data-list]').innerHTML = variants.reduce(
          (a, variant, index) => {
            variantDetails.set(variant.handle, variant.variantData)
            const initial =
              variant.variantData.find(
                (item) =>
                  item.title === selectedVariantTitle &&
                  item.available === true,
              ) ?? null

            const disabledState = selectedVariantTitle && !initial
            const variantUrl = initial ? `?variant=${initial.id}` : ''

            const url = `/products/${variant.handle}${variantUrl}`

            return `${a}<a data-index="${index}" ${disabledState ? 'disabled' : ''} data-id="${variant.handle}" data-pathname="${url}" class='carousel--cell variant--swatch ${variant.colourway.value === colourway ? 'variant--swatch__active' : ''}' href="${url}">
                <img alt="Colour Swatch for ${variant.colourway.value}"loading="lazy" src="${variant.image}" width="24" height="24" class="swatch-image" />
                <span class="visually-hidden">View ${variant.colourway.value}</span>
            </a>`
          },
          '',
        )

        const initial =
          node
            .querySelector('.variant--swatch__active')
            ?.getAttribute('data-index') ?? 0

        new Carousel(node.querySelector('.carousel'), {
          initial: Number(initial),
        })

        node.querySelectorAll('.variant--swatch').forEach((ele) => {
          const setSwatchState = ({ details = {} }) => {
            const data = variantDetails.get(ele.getAttribute('data-id')) ?? {}
            const selectedVariantDetails =
              data.find(
                (option) => option.title === details.variant?.title ?? '',
              ) ?? null

            const url = new URL(ele.href)
            if (selectedVariantDetails) {
              url.searchParams.set('variant', selectedVariantDetails.id)
            } else {
              url.searchParams.delete('variant')
            }
            const variantURL = `${url.pathname}${url.search}`

            ele.setAttribute('data-pathname', variantURL)
            ele.href = variantURL

            ele.toggleAttribute(
              'disabled',
              !selectedVariantDetails || !selectedVariantDetails.available,
            )
          }

          ele.addEventListener('click', (e) => {
            e.preventDefault()
            productPageNextLoad(ele.href)
          })

          ctx.on(EVENTS.productChange, (_, details) => {
            ele.classList.toggle(
              'variant--swatch__active',
              `${details.url}` === ele.getAttribute('data-pathname') ||
                `${details.url}?variant=${details.variant}` ===
                  ele.getAttribute('data-pathname'),
            )
          })

          ctx.on(EVENTS.variantChange, (_, details) => {
            selectedVariantTitle = details.variant.title
            setSwatchState({ details })
          })
        })
      })

      ctx.on(EVENTS.productChange, () => {
        const variants =
          SAXX.Product.SessionProductLineData[node.getAttribute('data-type')] ??
          []
        const colourway = decodeHTMLEntities(SAXX.Product.Colourway)
        const name = variants.find(
          (variant) => variant.colourway.value === colourway,
        )

        title.innerHTML = name ? name.colourway.value : ''
      })
    }),
    mainProductMultiPacks: SAXX.Init.Component((node, ctx) => {
      ctx.on(EVENTS.relatedDataFetch, (_, details) => {
        const options = new Map(Object.entries(details.relatedPackageQuantity))
        const packSizes = Object.entries(
          options.get(SAXX.Product.Silhouette) ?? {},
        )

        node.parentElement.setAttribute('disabled', packSizes.length <= 1)

        if (!packSizes.length) return

        node.querySelector('[data-list]').innerHTML = packSizes.reduce(
          (a, [key, value]) => {
            return `${a}<div class='input--swatch'>
                <a
                  href='${value}'
                  class='input--swatch-link ${key === SAXX.Product.PackQuantity ? 'active' : ''}'
                  >${key}</a
                >
              </div>`
          },
          '',
        )
      })
    }),
    mainProductSilhouettes: SAXX.Init.Component((node, ctx) => {
      ctx.on(EVENTS.relatedDataFetch, (_, details) => {
        const alternatives = new Map(Object.entries(details.relatedSilhouette))
        alternatives.delete(SAXX.Product.Silhouette)

        node.parentElement.setAttribute('disabled', alternatives.size < 1)

        const links = Array.from(alternatives).map(([key, value]) => {
          return ` <a href="${value}" class="text--bold">${key}</a>`
        })
        node.innerHTML = `Also available in:${links.join(',')}`
      })
    }),
    mainProductBuyButton: SAXX.Init.Component((node, ctx) => {
      ctx.on(EVENTS.productChange, (_, details) => {
        node.innerHTML =
          details.productPage.querySelector(`.buy-button--layout`).innerHTML
      })
    }),
    mainProductAddToCart: SAXX.Init.Component((node, ctx) => {
      const parentSection = node.closest('.main-product')

      ctx.on(EVENTS.variantChange, (_, details) => {
        node.disabled = !details.variant.available
        node.querySelector('.button-text').innerHTML =
          details.variant.available ? `Add To Cart` : 'Out of stock'

        if (
          node.querySelector('.atc--price') &&
          !parentSection.classList.contains('shoplift-test-product')
        ) {
          const regularPrice = formatMoney(details.variant.price, true)

          node.querySelector('.atc--price').innerHTML =
            details.variant.available ? regularPrice : ''
        }
      })

      node.addEventListener('click', (e) => {
        if (node.disabled || !node.form.checkValidity()) {
          e.preventDefault()

          if (node.id === 'floating-primary__add-to-cart') {
            scrollToHandler('#product-form')
          }

          ctx.emit(EVENTS.fieldsetValidate)
        }
      })
    }),
    mainProductFloatingProductBar: SAXX.Init.Component((node, ctx) => {
      const setFloatingActionButtonOffset = () => {
        document
          .querySelector(':root')
          .style.setProperty(
            '--floating-action-button-base-offset',
            `${
              node.querySelector('.main-product--floating-add-to-cart')
                ?.clientHeight / 16 ?? 0
            }rem`,
          )
      }

      setFloatingActionButtonOffset()

      ctx.on(EVENTS.productChange, (_, details) => {
        node.innerHTML = details.productPage.querySelector(
          '.main-product--floating-buy-button',
        ).innerHTML

        setFloatingActionButtonOffset()
      })
    }),
    mainProductSelectedSize: SAXX.Init.Component((node, ctx) => {
      ctx.on(EVENTS.variantChange, (_, details) => {
        node.innerHTML = `&nbsp;-&nbsp;${details.variant.title}`
      })
    }),
    mainProductForm: SAXX.Init.Component((node, ctx) => {
      const toggleInputGroupState = (id, state) => {
        const targetFieldset = document.getElementById(id)

        targetFieldset.disabled = !state
        targetFieldset
          .querySelectorAll('input:not([type="hidden"]),textarea')
          .forEach((ele) => {
            ele.disabled = !state
          })
      }

      const mainProductFormChangeEvent = (
        { target = null } = { target: null },
      ) => {
        ctx.emit(EVENTS.fieldsetValidate)

        const disableToggleTargets = Array.from(
          node.querySelectorAll('[data-disable-target]'),
        )
        const formInputs = Array.from(node.querySelectorAll('select, fieldset'))
        const variantInput = node.querySelector('input[name="id"]')
        const variant = getSelectedVariantData({ fields: formInputs })
        const disableToggle = disableToggleTargets.find((ele) => ele === target)

        if (disableToggle) {
          toggleInputGroupState(
            disableToggle.getAttribute('data-disable-target'),
            disableToggle.checked,
          )
        }

        if (!variant) return

        variantInput.value = variant.id

        ctx.emit(EVENTS.variantChange, null, { variant })
      }

      node.addEventListener('change', mainProductFormChangeEvent)

      node.addEventListener('submit', async (e) => {
        e.preventDefault()

        const formData = new FormData(node)

        const variantInput = node.querySelector(
          `input[type="radio"][data-id="${formData.get('id')}"]`,
        )
        formData.append(
          'properties[_ORIGINAL_PRICE]',
          variantInput.getAttribute('data-original-price'),
        )
        if (variantInput.hasAttribute('data-final-sale')) {
          formData.append('properties[_ASRC]', 'Final Sale')
        }

        const response = await addItemById(formData)

        ctx.emit(THEME.drawerControlInteraction, null, {
          controlElement: 'slide-out-cart',
        })

        if (!response || response.status === 422) {
          return ctx.emit(CARTSTATES.UPDATINGERROR, null, {
            cart: response,
          })
        }

        ctx.emit(CARTSTATES.UPDATED, null, {
          addedLineItems: response.items,
          cart: response,
        })
      })

      ctx.on(EVENTS.productChange, (_, details) => {
        node.innerHTML =
          details.productPage.querySelector('#product-form').innerHTML
      })
    }),
    mainProductStyleCode: SAXX.Init.Component((node, ctx) => {
      ctx.on(EVENTS.productChange, () => {
        node.innerHTML = SAXX.Product.StyleCode
      })
    }),
  }

  Object.assign(SAXX.Init.Components, components)

  SAXX.Init.Callbacks.push(() => {
    return () => {
      const baseSwatchObject = {
        key: SAXX.Product.ProductLineDataKey,
        requestFilter: {
          type: SAXX.Product.ProductType,
          collection: SAXX.Product.CollectionHandle,
          silhouette: SAXX.Product.Silhouette,
          packQuantity: SAXX.Product.PackQuantity,
        },
        solid: [],
        pattern: [],
        sizes: [],
      }
      const baseRelatedObject = {
        key: SAXX.Product.RelatedDetailsDataKey,
        requestFilter: {
          type: SAXX.Product.ProductType,
          collection: SAXX.Product.CollectionHandle,
        },
        relatedPackageQuantity: {},
        relatedSilhouette: {},
      }

      if (SAXX.Product.Collection === '') {
        SAXX.App.emit(EVENTS.dataFetch, null, baseSwatchObject)
        SAXX.App.emit(EVENTS.relatedDataFetch, null, baseRelatedObject)
        return
      }

      if (SAXX.Product.SessionProductLineData) {
        SAXX.App.emit(
          EVENTS.dataFetch,
          null,
          SAXX.Product.SessionProductLineData,
        )
      } else {
        executeGraphQlQuery(
          SAXX.Shop.APIKey,
          `query ($id: ID!, $filter: [ProductFilter!]) @inContext(country: ${window.Shopify.country.toUpperCase()}, language: ${window.Shopify.locale.toUpperCase()}) {
          collection(id: $id) {
            products(first: 200, filters: $filter) {
              nodes {
                handle
                colourway: metafield(namespace: "colourway", key: "primary") {
                  value
                }
                swatch: metafield(namespace: "content", key: "swatch") {
                  reference {
                    ... on MediaImage {
                      image {
                        url(transform: {maxWidth: 72})
                      }
                    }
                  }
                }
                featuredImage {
                  url(transform: {maxWidth: 72})
                }
                print: metafield(namespace: "print", key: "style") {
                  value
                }
                hidden: metafield(namespace: "seo", key: "hidden") {
                  value
                }
                variants(first: 50) {
                  edges {
                    node {
                      id
                      title
                      availableForSale
                    }
                  }
                }
              }
            }
          }
        }`,
          SAXX.Product.SwatchesFilter,
        )
          .then((res) => {
            if (res.errors) {
              throw new Error(res.errors[0].message)
            }

            const data = baseSwatchObject

            res.data.collection.products?.nodes?.forEach((product) => {
              if (product.hidden?.value === '1') return

              const type = product.print?.value.toLowerCase() ?? 'solid'

              product.image =
                product.swatch?.reference.image.url ??
                product.featuredImage?.url ??
                ''

              product.variantData = product.variants.edges.map((variant) => {
                return {
                  id: variant.node.id.split('/').pop(),
                  title: variant.node.title,
                  available: variant.node.availableForSale,
                }
              })

              data[type].push(product)
            })

            SAXX.Session.StoredProductDetails.push(data)
            sessionStorage.setItem(
              'storedProductDetails',
              JSON.stringify(SAXX.Session.StoredProductDetails),
            )

            SAXX.App.emit(EVENTS.dataFetch, null, data)
          })
          .catch((e) => {
            console.error(e)
            SAXX.App.emit(EVENTS.dataFetch, null, baseSwatchObject)
          })
      }

      const relatedDetails =
        SAXX.Session.StoredRelatedProducts.find(
          (item) => item.key === SAXX.Product.RelatedDetailsDataKey,
        ) ?? null

      if (relatedDetails) {
        SAXX.App.emit(EVENTS.relatedDataFetch, null, relatedDetails)
      } else {
        executeGraphQlQuery(
          SAXX.Shop.APIKey,
          `query ($id: ID!, $filter: [ProductFilter!]) @inContext(country: ${window.Shopify.country.toUpperCase()}, language: ${window.Shopify.locale.toUpperCase()}) {
          collection(id: $id) {
            products(first: 200, filters: $filter, sortKey: PRICE) {
              nodes {
                handle
                hidden: metafield(namespace: "seo", key: "hidden") {
                  value
                }
                silhouette: metafield(namespace: "silhouette", key: "primary") {
                  value
                }
                packageQuantity: metafield(namespace: "package", key: "quantity") {
                  value
                }
              }
            }
          }
        }`,
          SAXX.Product.RelatedFilter,
        )
          .then((res) => {
            if (res.errors) {
              throw new Error(res.errors[0].message)
            }

            const data = baseRelatedObject

            res.data.collection.products?.nodes.forEach((product) => {
              if (product.hidden?.value === '1') return
              if (
                product.silhouette === null &&
                product.packageQuantity === null
              )
                return

              const quantity = product.packageQuantity.value
              const silhouette = product.silhouette.value

              if (
                !Object.prototype.hasOwnProperty.call(
                  data.relatedSilhouette,
                  silhouette,
                )
              ) {
                data.relatedSilhouette[silhouette] =
                  `/products/${product.handle}`
              }

              if (
                !Object.prototype.hasOwnProperty.call(
                  data.relatedPackageQuantity,
                  silhouette,
                )
              ) {
                data.relatedPackageQuantity[silhouette] = {}
              }

              if (
                !Object.prototype.hasOwnProperty.call(
                  data.relatedPackageQuantity[silhouette],
                  quantity,
                )
              ) {
                data.relatedPackageQuantity[silhouette][quantity] =
                  `/products/${product.handle}`
              }
            })

            SAXX.Session.StoredRelatedProducts.push(data)
            sessionStorage.setItem(
              'storedRelatedProducts',
              JSON.stringify(SAXX.Session.StoredRelatedProducts),
            )

            SAXX.App.emit(EVENTS.relatedDataFetch, null, data)
          })
          .catch((e) => {
            console.error(e)
            SAXX.App.emit(EVENTS.relatedDataFetch, null, baseRelatedObject)
          })
      }
    }
  })
})()
